import { useQuery } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'
import { GetTasksUsageSumQuery } from '@indigohive/cogfy-types/endpoints/getTasksUsageSum'

export function useTasksUsageSum (
  workspace: string,
  query: GetTasksUsageSumQuery
) {
  const cogfy = useCogfy()

  const getWorkspaceCreditsUsage = useQuery({
    queryKey: ['getTasksUsageSum', workspace, query],
    queryFn: ({ signal }) => cogfy.getTasksUsageSum(query, { signal })
  })

  return getWorkspaceCreditsUsage
}
